/** @jsx jsx */
import { jsx } from '@emotion/react';

import user from 'js/lib/user';

import { Link } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';

import _t from 'i18n!nls/xdp';

const EnterpriseThinBannerCta = () => {
  const track = useTracker();
  const eventingProductData = useEventingProductData();

  return (
    <Link
      component={TrackedA}
      href={`/business?utm_medium=coursera&utm_source=xdp&utm_campaign=website&utm_content=c4b-xdp-thin-card&utm_term=${
        user.isAuthenticatedUser() ? 'in' : 'out'
      }`}
      trackingName="upsell_coursera_business"
      typographyVariant="subtitleMedium"
      variant="quiet"
      onClick={() => {
        track('click_upsell_card', {
          upsellType: 'enterprise',
          pageSection: {
            sectionName: 'thin_banner',
          },
          ...eventingProductData,
        });
      }}
    >
      {_t('Learn more about Coursera for Business')}
    </Link>
  );
};

export default EnterpriseThinBannerCta;
